import React from 'react'
import ButtonNext from './ButtonNext'
import clsx from 'clsx'

const ButtonNextWithLine = ({ onClick, className, disabled = false }) => {
  return <div className={clsx('btn-next-line', className)}>
    <ButtonNext className='btn-next--with-line' onClick={onClick} disabled={disabled} />
  </div>
}

export default ButtonNextWithLine
